const skeleton = {
  styleOverrides: {
    root: {}
  }
};

export default skeleton;
